import { UrlBase, UrlBaseServicios, URL_PLUGIN, URL_PLUGIN_FRONTEND, URL_PLUGIN_SEGUROS } from '../parametros';



/*
    GENERAL
*/

export const urlGenerarOtraCotizacion = `${URL_PLUGIN}generar-otra-cotizacion`;
export const urlGetProductos = `${URL_PLUGIN}get-lista-microseguros-v2`;
export const urlGetCotizacionById = (idCotizacion) =>
  `${URL_PLUGIN}get-data-cotizacion&idCotizacion=${idCotizacion}`;
export const urlGetProudctoById = `${URL_PLUGIN}get-microseguro-by-id`;
export const urlSetProductoCotizacion = `${URL_PLUGIN}set-producto-cotizacion`;
export const setTitularUrl = `${URL_PLUGIN_FRONTEND}set-titular`;
export const getUrlCrearCotizacion = () => `${URL_PLUGIN}crear-cotizacion-login `;


// export const getPtpPagos = `${UrlBase}frontend/web/index.php?r=placetopay/pagos-reference`;

export const getPtpPagos = (idCotizacion, empAplica) =>
  `${UrlBaseServicios}placetopay/pagos/${empAplica}/${idCotizacion}`;
export const getPtpPagosXCedula = (cedula, fecha1, fecha2) =>
  `${UrlBase}/frontend/web/index.php?r=placetopay/consultar-pagosx-cedula&cedula=${cedula}&fechaIn=${fecha1}&fechaFin=${fecha2}`;
export const getPtpListadoPagosPendientes = (idCotizacion, historial) =>
  `${URL_PLUGIN_FRONTEND}poliza/historial-pagos-pendientes&idCotizacion=${idCotizacion}&historial=${historial}`;

// `${getPtpPagos}&idReferencia=${ref}`

export const urlSetBeneficiarios = `${URL_PLUGIN}set-beneficiarios`;
export const urlTitularAsBeneficiario = (idCotizacion) =>
  `${URL_PLUGIN}titular-as-beneficiario&idCotizacion=${idCotizacion}`;
export const urlSetTitularAsBeneficiarion = (idCotizacion) =>
  `${URL_PLUGIN}titular-as-beneficiario&idCotizacion=${idCotizacion}`;
export const urlEditVigencia = `${URL_PLUGIN}edit-vigencia-cotizacion`;
/*
  POLIZAS
*/

export const urlVerificarPoliza = `${URL_PLUGIN}verificar-estado-poliza`;

export const urlIngresarPoliza = (idCotizacion) =>
  `${URL_PLUGIN}ingresar-poliza&idCotizacion=${idCotizacion}`;

/*
  EVICERTIA
*/

export const urlFirmarDocumentosEV = `${URL_PLUGIN}firmar-documentos-evicertia`;

/*
    PLACE TO PAY
*/

export const urlConsultaEstadoSuscripcionPtP = (idSuscripcion) =>
  `${UrlBaseServicios}placetopay/retorna/suscripcion/${idSuscripcion}`; // retorna-ptp-suscripcion

export const urlHacerPagoSuscripcionPtp = `${UrlBase}frontend/web/index.php?r=placetopay/pago-suscripcion-generico`;

export const urlConsultarPagoPtpPendienteSuscripcion = (idCotizacion, empCodigo) =>
  `${UrlBaseServicios}placetopay/sonda/${empCodigo}/${idCotizacion}`; // sonda

export const urlPreguntasFrecuentesPtp = `${UrlBase}frontend/web/index.php?r=placetopay/preguntas-frecuentes`;

export const urlPagosPendientes = `${URL_PLUGIN_FRONTEND}poliza/obtener-pagos-pendientes&idCotizacion=`
export const urlPagarPendientes = `${URL_PLUGIN_FRONTEND}poliza/pagar-pendientes&idCotizacion={cotizacion}&idSuscripcion=`


/*
  ENVIAR CORREO CLIENTE PARA REALIZAR EL PAGO
*/

export const urlEnviarCorreoClientePago = `${URL_PLUGIN}correo-pago`;

export const urlFormaPago = `${URL_PLUGIN_SEGUROS}cotizacion/forma-pago`;


/*
  FLUJO 6
  AIGMETROPOLITANA
*/

export const urlEnviarCotizacionAig = (idCotizacion) =>
  `${URL_PLUGIN}enviar-cotizacion-aig&idCotizacion=${idCotizacion}`;

export const urlEnviarCotizacionAigAutoKm = (idCotizacion) =>
  `${URL_PLUGIN}enviar-cotizacion-landing&idCotizacion=${idCotizacion}`;

/*
FLUJO 10 
MOVISTAR Y COVERME
*/

export const urlBeforeSavePoliza = (idCotizacion) =>
  `${URL_PLUGIN_FRONTEND}cotizacion/before-save-poliza&idCotizacion=${idCotizacion}`;

// FLUJO 

export const urlValidarmx365 = () => `${URL_PLUGIN_SEGUROS}validation/add-product`;
export const urlValidaIdEmail = (identificacion, email) => `${URL_PLUGIN_FRONTEND}validation/existe-identificacion&identificacion=${identificacion}&correo=${email}`;


export const urlUpdateCotizacionById = () => `${URL_PLUGIN_FRONTEND}actualizar-cotizacion`;
export const urllistaCumplimientoSunidos = () => {
  let url = URL_PLUGIN_FRONTEND.replace("plugin", "site");
  return `${url}consulta-lista-cumplimiento`;
}

export const urlNotificarListaCumplimiento = () => {
  const url = `${URL_PLUGIN_FRONTEND}`.replace("plugin", "site");
  return `${url}notificar-listas-cumplimiento`
}
export const urlDepreciacionSunidos = () => `${URL_PLUGIN_FRONTEND}cotizacion/depreciacion`;
export const urlCertificadoCotizacion = (idCotizacion) => `${URL_PLUGIN_FRONTEND}cotizacion/guardar-solicitud&idCotizacion=${idCotizacion}`;

export const urlCorreoInicialNotificacion = (idCotizacion, tipocorreo) => `${URL_PLUGIN_FRONTEND}cotizacion/correo-inicial-sunidos&idCotizacion=${idCotizacion}&tipoCorreo=${tipocorreo}`;//bienvenida
export const urlcalcularVigenciaPoliza = (idCotizacion) => {
  // let url = URL_PLUGIN_FRONTEND.replace("plugin", "polizas");
  return `${URL_PLUGIN_FRONTEND}poliza/calcular-vigencia-poliza&idCotizacion=${idCotizacion}`;//bienvenida
}
export const urlValDispositivo = (codigoCore) => `${URL_PLUGIN_FRONTEND}cotizacion/valor-dispositivo&codigoCore=${codigoCore}`//bienvenida
export const urlRegistroCivil = () => `http://middlewaresegurosdev74-env.eba-96bm8f3u.us-east-1.elasticbeanstalk.com/frontend/web/index.php?r=cotizaciones/consultar-datos-cedula-plugin&empresa=HUMANA&plataforma=WEB`//bienvenida
export const urlCnsultarDatosProductoMx365 = () => `${URL_PLUGIN_FRONTEND}consultar-datos-producto`
export const urlGetUserAgencias = () => `${URL_PLUGIN}obtener-usuarios-agencia`
export const urlCrearPago365 = () => {
  const url = `${URL_PLUGIN_FRONTEND}`.replace("plugin", "garantia365");
  return `${url}realizar-pedido`
}
export const enviarCorreoEvicertia = () => `${URL_PLUGIN_FRONTEND}enviar-correo-firma-evicertia`
export const firmarDocumentos = () => `${URL_PLUGIN}firmar-documentos-evicertia`
export const urlGetProductosCanal = () => `${URL_PLUGIN_FRONTEND}obtener-canales-por-agencias-usuario`
export const urlAgenciasUsuario = () => `${URL_PLUGIN_FRONTEND}obtener-agencias-usuario`
export const urlActualizarEstadoFirma = () => `${URL_PLUGIN_FRONTEND}actualizar-estado-firma`
export const urlStripePago = () => `${UrlBaseServicios}stripe/checkout/mx365/WEB`

export const urlGetUrlPdfCotizacion = `${URL_PLUGIN_FRONTEND}cotizacion/actualiza-pdf-cotizacion&idCotizacion=`;
